export const popularFallbackDestinations = [
  {
    label: "Gatlinburg Cabin Getaways",
    secondary: "Tennessee, USA",
    path: "/vacation-rentals/Gatlinburg--Tennessee--USA",
  },
  {
    label: "San Diego Beach Vacations",
    secondary: "California, USA",
    path: "/vacation-rentals/San-Diego--California--USA",
  },
  {
    label: "Las Vegas Pool Escapes",
    secondary: "Nevada, USA",
    path: "/vacation-rentals/Las-Vegas--NV?FeaturesAndAmenities=1002",
  },
]
